import { FormTypes } from '@oneblink/types'
import juice from 'juice'
import { findElement, replaceElement } from './definition-manipulation'
import { v4 as uuid } from 'uuid'

export type OrderSummaryItem = {
  label: string
  quantity: number
  language: string
}

export function generateOrderSummaryTable(
  orderSummaryItems: OrderSummaryItem[],
): FormTypes.HtmlElement {
  const tableElement: FormTypes.HtmlElement = {
    type: 'html',
    defaultValue: ' ',
    name: 'orderSummaryTable',
    id: uuid(),
    conditionallyShow: false,
    label: 'Order Summary Table',
  }
  if (!orderSummaryItems.length) {
    return tableElement
  }

  const tableData = `<div class="order-summary-table">
  ${orderSummaryItems.reduce((orderSummaryRows, orderSummary) => {
    orderSummaryRows += `
          <div class="order-summary-table__item">
            <div class="order-summary-table-item__label">${orderSummary.label} - ${orderSummary.language}</div>
            <div class="order-summary-table-item__quantity">${orderSummary.quantity}</div>
          </div>`
    return orderSummaryRows
  }, '')}
 
  </div>`

  tableElement.defaultValue = tableData

  return tableElement
}

export function setOrderSummaryTableInlineStyles(definition: FormTypes.Form) {
  const stylesToInject = `
  <style>
    .order-summary-table {
      width: 100%
    }
    
    .order-summary-table__item {
      display: flex;
      padding: 12px;
    }
    
    .order-summary-table-item__label {
      flex-grow: 1;
    }
    
    .order-summary-table-item__quantity {
      text-align: right;
      width: 32px;
    }
  </style>
  `

  const existingSummary = findElement<FormTypes.HtmlElement>(
    definition,
    'orderSummaryTable',
  )
  if (existingSummary) {
    const newHtml = juice(
      `${stylesToInject}\n${existingSummary.value.defaultValue}`,
    )
    existingSummary.value.defaultValue = newHtml
    definition.elements = replaceElement(
      definition.elements,
      existingSummary.value,
      existingSummary.value,
    )
  }
}
